<template>
    <div class="jump-usercenter nav-bar-fixed">
        <van-nav-bar title="我的账单" left-arrow fixed @click-left="back"/>
        <van-row class="jump-usercenter-search" type="flex">
            <van-col span="5">
                月结月份
            </van-col>
            <van-col span="6" class="search-field">
                <van-field placeholder="2019-01" v-model="beginMonth"/>
            </van-col>
            <van-col span="1">
                &nbsp;-
            </van-col>
            <van-col span="6" class="search-field">
                <van-field placeholder="2019-02" v-model="endMonth"/>
            </van-col>
            <van-col span="6" class="text-right">
                <i class="iconfont icon-sousuo"></i>
            </van-col>
        </van-row>
        <div class="bill-item-hd">

            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >

                <van-row class="bill-item" v-for="(item,index) in list">
                    <van-col span="12">
                        序号:{{index+1}}
                    </van-col>
                    <van-col span="12" class="text-right">
                        月结月份 {{item.billingMonth}}
                    </van-col>
                    <van-col span="24" >
                        <p><span class="aready">{{item.confirm_status_name}}</span><a @click="details(item.milkConfirmId)"><span
                                class="detail">详情</span></a>
                        </p>
                    </van-col>

                </van-row>

            </van-list>
        </div>
    </div>
</template>
<script>
    import {NavBar, Row, Col, Field, Button, List} from "vant";

    export default {
        name: "userBill",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Field.name]: Field,
            [List.name]: List,
            [Button.name]: Button
        },
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1,
                beginMonth: '',
                endMonth: ''
            };
        },
        methods: {
            back() {
               this.$router.replace({"path": "/usercent"})
            }, onLoad() {
                let that = this
                // 异步更新数据
                that.$api.post(
                    that.jumuc.userCenter.milkImportConfirmList,
                    {
                        "currentPage": that.page,
                        "pageSize": 10,
                        "beginMonth": that.beginMonth,
                        "endMonth": that.endMonth
                    },
                    successRes => {
                        let orderlist = successRes.data.list
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        that.page = successRes.data.pageNum + 1
                        that.total = successRes.data.total
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (this.list.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )

            }, details(id) {
                let that = this
                that.$router.push({
                    path: '/user/bill/detail',
                    query:{
                        id:id
                    }
                })
            }, saveUpdate(id, status) {
                let that=this
                that.$api.post(
                    that.jumuc.userCenter.milkImComfirmDeal,
                    {
                        "remark": '',
                        "status": status,
                        "milkConfirmId": id
                    },
                    successRes => {
                        that.$toast(successRes.msg);
                        if (successRes.success) {
                            that.$router.push({"path": "/user/bill"})
                        }
                    })
            }
        }
    };
</script>
<style lang="less">
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-usercenter {


        &-search {
            background-color: #fff;
            padding: 0 15px;
            margin-bottom: 10px;
            font-size: 16px;
            & > div {
                align-items: center;
                line-height: 45px;
            }
            .search-field .van-field {
                padding: 10px 0;
            }
            input {
                border-bottom: 1px solid #ebedf0;
                color: @bule-thame;
            }
            i {
                color: @bule-thame;
                font-size: 18px;
            }
        }
        .bill-item-hd {
            padding: 0 10px;
            .bill-item {
                background-color: #fff;
                margin-bottom: 10px;
                padding: 10px;
                font-size: 14px;
                p {
                    text-align: right;
                    font-size: 14px;
                    padding: 10px 0;
                    span {
                        margin-left: 15px;
                        &.aready {
                            color: @bule-thame;
                        }
                        &.detail {
                            color: #f5a623;
                        }
                    }
                    button {
                        padding: 0 10px;
                        color: #fff;
                        background-color: @bule-thame;
                        border-radius: 10px;
                        span {
                            margin: 0;
                        }
                    }
                }
            }
        }
    }
</style>

